<template>
  <div class="page">
    <div class="header-wp">
      <img src="@/assets/images/mobile/header.png" class="bg-header" />
      <div class="text-wp">
        <div class="text-inner-wp">
          <span class="title">賞金獵人實時監控系統</span>
        </div>
      </div>
    </div>
    <div class="date-wp">
      <span class="text">{{dateObj.year}}年{{dateObj.month}}月{{dateObj.day}}日 {{dateObj.hour}}:{{dateObj.minute}}:{{dateObj.second}} 星期{{dateObj.week}}</span>
    </div>
    <div class="title-content">
      <svg-icon icon-class="arrow-right"></svg-icon>
      <span class="text">估值調整協議VAM</span>
    </div>
    <div class="line-2-wp">
      <img src="@/assets/images/mobile/bg-1.png" class="bg-item" />
      <div class="item-content-wp">
        <div class="item-content-inner-wp">
          <div class="item-wp">
            <div class="icon-wp">
              <img src="@/assets/images/icon-1.png" class="icon-1" />
            </div>
            <div class="item-value-wp">
              <div class="value-row-1-wp">
                <span class="value-1">{{config.value_1}}</span>
                <span class="value-1-unit">件</span>
              </div>
              <div class="value-row-2-wp">
                <span class="value-2">待辦</span>
              </div>
            </div>
          </div>
          <div class="item-wp">
            <div class="icon-wp">
              <img src="@/assets/images/icon-2.png" class="icon-2" />
            </div>
            <div class="item-value-wp">
              <div class="value-row-1-wp">
                <span class="value-1">{{config.value_2}}</span>
                <span class="value-1-unit">件</span>
              </div>
              <div class="value-row-2-wp">
                <span class="value-2">已排期</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="line-3-wp">
      <img src="@/assets/images/mobile/bg-2.png" class="bg-item" />
      <div class="item-content-wp">
        <div class="item-content-inner-wp">
          <div class="item-wp">
            <div class="icon-wp">
              <img src="@/assets/images/icon-3.png" class="icon-1" />
            </div>
            <div class="item-value-wp">
              <div class="value-row-1-wp">
                <span class="value-1">{{config.value_3}}</span>
                <span class="value-1-unit">件</span>
              </div>
              <div class="value-row-2-wp">
                <span class="value-2">辦理中</span>
              </div>
            </div>
          </div>
          <div class="item-wp">
            <div class="icon-wp">
              <img src="@/assets/images/icon-4.png" class="icon-2" />
            </div>
            <div class="item-value-wp">
              <div class="value-row-1-wp">
                <span class="value-1">{{config.value_4}}</span>
                <span class="value-1-unit">件</span>
              </div>
              <div class="value-row-2-wp">
                <span class="value-2">已完成</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="line-4-wp">
      <div class="icon-wp">
        <img src="@/assets/images/mobile/bg-3.png" class="bg-3" />
      </div>
      <div class="item-content-wp">
        <div class="item-content-inner-wp">
          <div class="title-wp">
            <svg-icon icon-class="arrow-right"></svg-icon>
            <span class="text">估值調整幣VAC</span>
          </div>
          <div class="number-wp">
            <div class="icon-wp">
              <img src="@/assets/images/icon-5.png" class="icon" />
            </div>
            <div class="number-item-content-wp">
              <div class="number-item-content-inner-wp">
                <span class="text">{{config.value_5}}</span>
              </div>
            </div>
          </div>
          <div class="progress-wp">
            <div class="progress-item-wp">
              <span class="text">歷史累計</span>
              <span class="value">{{config.value_6}}</span>
            </div>
            <div class="sep-v"></div>
            <div class="progress-item-wp">
              <span class="text">今日累計</span>
              <span class="value">{{config.value_7}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="line-5-wp">
      <div class="icon-wp">
        <img src="@/assets/images/mobile/bg-3.png" class="bg-4" />
      </div>
      <div class="item-content-wp">
        <div class="item-content-inner-wp">
          <div class="title-wp">
            <svg-icon icon-class="arrow-right"></svg-icon>
            <span class="text">距交易所審覈進度</span>
          </div>
          <div class="number-wp">
            <div class="icon-wp">
              <img src="@/assets/images/icon-6.png" class="icon" />
            </div>
            <div class="number-item-content-wp">
              <div class="number-item-content-inner-wp">
                <span class="text">{{config.value_8}}%</span>
              </div>
            </div>
          </div>
          <div class="progress-wp">
            <div class="progress-item-wp">
              <span class="text">昨日進度</span>
              <span class="value">{{config.value_9}}%</span>
            </div>
            <div class="sep-v"></div>
            <div class="progress-item-wp">
              <span class="text">今日進度</span>
              <span class="value">{{config.value_10}}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="title-content title-2">
      <svg-icon icon-class="arrow-right"></svg-icon>
      <span class="text">BTC實時價格</span>
    </div>
    <div class="line-6-wp">
      <img src="@/assets/images/mobile/bg-4.png" class="bg-item" @load="chart1Loaded"/>
      <div class="item-content-wp">
        <div class="item-content-inner-wp">
          <v-chart v-if="chart1HeightReady" ref="chart_1" class="chart" :option="option"></v-chart>
        </div>
      </div>
    </div>
    <div class="title-content title-3">
      <svg-icon icon-class="arrow-right"></svg-icon>
      <span class="text">全球快訊</span>
    </div>
    <div class="line-7-wp">
      <img src="@/assets/images/mobile/bg-5.png" class="bg-item" />
      <div class="item-content-wp">
        <div class="item-content-inner-wp">
          <div class="zx-wp">
            <div class="zx-item-wp" v-for="(zx, idx) in zxList" :key="idx">
              <span class="zx-date">{{zx.date}}</span>
              <span class="zx-title">{{zx.title}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="line-8-wp">
      <div class="title-content">
        <svg-icon icon-class="arrow-right"></svg-icon>
        <span class="text">布倫特油</span>
      </div>
      <div class="chart-wp">
        <img src="@/assets/images/mobile/bg-6.png" class="bg-item" @load="chart2Loaded" />
        <div class="item-content-wp">
          <div class="item-content-inner-wp">
            <v-chart v-if="chart2HeightReady" ref="chart_2" class="chart" :option="option2"></v-chart>
          </div>
        </div>
      </div>
    </div>
    <div class="line-9-wp">
      <div class="title-content">
        <svg-icon icon-class="arrow-right"></svg-icon>
        <span class="text">現貨黃金 {{alter3}}</span>
      </div>
      <div class="chart-wp">
        <img src="@/assets/images/mobile/bg-6.png" class="bg-item" @load="chart3Loaded" />
        <div class="item-content-wp">
          <div class="item-content-inner-wp">
            <v-chart v-if="chart1HeightReady" ref="chart_3" class="chart" :option="option3"></v-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import SvgIcon from "@/components/svg/SvgIcon";
import apiClient from "@/util/apiClient";
// import {layer} from "vue3-layer";

export default {
  name: 'PageMobile',
  components: {
    SvgIcon,
  },
  props: {},
  data: function () {
    return {
      config: window._config,
      dateObj: {
        year: '',
        month: '',
        day: '',
        hour: '',
        minute: '',
        second: '',
        week: ''
      },
      interval: null,
      apiInterval: null,
      weekMap: {
        'week_0': '日',
        'week_1': '一',
        'week_2': '二',
        'week_3': '三',
        'week_4': '四',
        'week_5': '五',
        'week_6': '六',
      },
      zxList: [],
      zxInterval: null
    }
  },
  created() {
    this.interval = setInterval(this.initDate, 1000)
    this.queryzx()
    this.zxInterval = setInterval(this.queryzx, 60000)
  },
  mounted() {
  },
  unmounted() {
    if (this.interval) {
      clearInterval(this.interval)
    }
    if (this.zxInterval) {
      clearInterval(this.zxInterval)
    }
  },
  computed: {
    ...mapGetters([
    ]),
  },
  methods: {
    initDate() {
      let date = new Date();
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = '0' + month.toString()
      }
      let day = date.getDate();
      if (day < 10) {
        day = '0' + day.toString()
      }
      let hour = date.getHours()
      if (hour < 10) {
        hour = '0' + hour.toString()
      }
      let minute = date.getMinutes()
      if (minute < 10) {
        minute = '0' + minute.toString()
      }
      let second = date.getSeconds()
      if (second < 10) {
        second = '0' + second.toString()
      }

      let week = date.getDay();

      this.dateObj = {
        year: date.getFullYear(),
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        week: this.weekMap['week_' + week]
      }
    },
    queryzx() {
      apiClient.get('jin10').then((res) => {
        if (res.status === 200) {
          let data = res.data;
          if (data.error === undefined) {
            let _zxList = [];
            data.forEach((item) => {
              if (item.title) {
                _zxList.push({
                  title: item.title,
                  content: item.content,
                  date: item.date,
                })
              }
            })
            this.zxList = _zxList;
          } else {
            console.log('error', data.error)
          }
        } else {
          // layer.msg('network error')
        }
      }).catch((e) => {
        console.log('e', e)
        // layer.msg('network error')
      })
    }
  }
}
</script>
<script setup>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart } from "echarts/charts";
import { UniversalTransition } from 'echarts/features';
import {GridComponent, TooltipComponent} from 'echarts/components'
import VChart from "vue-echarts";
import {onUnmounted, ref} from "vue";

use([
  GridComponent,
  CanvasRenderer,
  TooltipComponent,
  LineChart,
  UniversalTransition
]);

const option = ref({});

const option2 = ref({});

const option3 = ref({});

const chart1HeightReady = ref(false);
const chart2HeightReady = ref(false);
const chart3HeightReady = ref(false);
function chart1Loaded() {
  chart1HeightReady.value = true;
  console.log('chart1HeightReady', chart1HeightReady.value)
}
function chart2Loaded() {
  chart2HeightReady.value = true;
  console.log('chart2HeightReady', chart2HeightReady.value)
}
function chart3Loaded() {
  chart3HeightReady.value = true;
  console.log('chart3HeightReady', chart3HeightReady.value)
}

const queryInterval = ref(null);

onUnmounted(() => {
  if (queryInterval.value !== null) {
    clearInterval(queryInterval.value);
  }
})

queryInterval.value = setInterval(() => {
  query1();
  query2();
  query3();
}, 60000)

query1();
query2();
query3();

const alter2 = ref(0);
const alter3 = ref(0);

function query1() {
  apiClient.get('query?symbol=BTCUSD').then((res) => {
    if (res.status === 200) {
      let data = res.data;
      if (data.error === undefined) {
        // console.log('data', data)
        let xAxis = []
        let series = []
        data.forEach((item) => {
          if (xAxis.length > 20) {
            return;
          }
          if (item.origin_time && item.current_price) {
            let xLabel = item.origin_time.substr(11, 5)
            let yValue = item.current_price
            xAxis.push(xLabel)
            series.push(yValue)
          }
        })
        setOption1({xAxis: xAxis, series: series})
      } else {
        console.log('error', data.error)
      }
    } else {
      // layer.msg('network error')
    }
  }).catch((e) => {
    console.log('e', e)
    // layer.msg('network error')
  })
}
function query2() {
  apiClient.get('query?symbol=LOC/USD').then((res) => {
    if (res.status === 200) {
      let data = res.data;
      if (data.error === undefined) {
        let series = [];
        let count = 0;
        data.forEach((item, idx) => {
          if (item.origin_time && item.current_price) {
            if (count < 10000) {
              series.push([
                item.origin_time,
                item.current_price
              ])
              count++;
            }
            alter2.value = item.alter;
          }
        })
        setOptions(option2, series, '#00BAFF', '#00BAFF')
      } else {
        console.log('error', data.error)
      }
    } else {
      // layer.msg('network error')
    }
  }).catch((e) => {
    console.log('e', e)
    // layer.msg('network error')
  })
}
function query3() {
  apiClient.get('query?symbol=exp_XAUUSD').then((res) => {
    if (res.status === 200) {
      let data = res.data;
      if (data.error === undefined) {
        let series = [];
        let count = 0;
        data.forEach((item) => {
          if (item.date && item.close) {
            if (count < 10000) {
              series.push([
                item.date,
                item.close
              ])
              count++;
            }
          }
        })
        setOptions(option3, series, '#FC57A6', '#00BAFF')
      } else {
        console.log('error', data.error)
      }
    } else {
      // layer.msg('network error')
    }
  }).catch((e) => {
    console.log('e', e)
    // layer.msg('network error')
  })
}
function setOptions(opt, data, color, color2) {
  opt.value = {
    backgroundColor: '',
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        params = params[0];
        return (
            params.data[0] +
            ' : ' +
            params.data[1]
        );
      },
      axisPointer: {
        animation: false
      }
    },
    xAxis: {
      type: 'time',
      splitLine: {
        show: false
      },
      axisLabel: {
        textStyle: {
          color: color2
        }
      }
    },
    yAxis: {
      type: 'value',
      boundaryGap: [0, '20%'],
      splitLine: {
        show: false
      },
      min: (value) => {
        // let min = value.min.toString();
        // let minArr = min.split('.')
        // let minLen = minArr[0].length
        // let diff = 10 ** (minLen - 1)
        // return parseInt(value.min - diff)

        let diff = value.max - value.min
        let min = 0;
        if (diff < value.min) {
          min = value.min - diff / 2;
        } else {
          min = value.min / 2;
        }
        if (min < 0) {
          min = 0;
        } else {
          min = Math.floor(min)
        }
        return min
        // return Math.floor(value.min - 1)
      },
      max: (value) => {
        // let min = value.min.toString();
        // let minArr = min.split('.')
        // let minLen = minArr[0].length
        // let diff = 10 ** (minLen - 1)
        // return parseInt(value.max + diff)

        let diff = value.max - value.min
        let max = value.max;
        if (diff < value.min) {
          max = value.max + diff / 2;
        } else {
          max = value.max + value.min;
        }

        return Math.floor(max + 1)
        // return Math.floor(value.max + 1)
      },
      axisLabel: {
        textStyle: {
          color: color2
        }
      }
    },
    series: [
      {
        data: data,
        showSymbol: false,
        type: 'line',
        itemStyle: {
          normal: {
            lineStyle: {
              color: color
            }
          }
        }
      }
    ],
    grid: {
      top: "20px",
      left: "50px",
      right: "20px",
      bottom: "30px"
    }
  }
}
function setOption1(data) {
  option.value = {
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        params = params[0];
        return (
            params.name +
            ' : ' +
            params.value
        );
      },
      axisPointer: {
        animation: false
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      splitLine: {
        show: false
      },
      data: data.xAxis,
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: false
      },
      min: (value) => {
        // let min = value.min.toString();
        // let minArr = min.split('.')
        // let minLen = minArr[0].length
        // let diff = 10 ** (minLen - 1)
        // return parseInt(value.min - diff)

        let diff = value.max - value.min
        let min = 0;
        if (diff < value.min) {
          min = value.min - diff / 2;
        } else {
          min = value.min / 2;
        }
        if (min < 0) {
          min = 0;
        } else {
          min = Math.floor(min)
        }
        return min

        // return Math.floor(value.min)
      },
      max: (value) => {
        // let min = value.min.toString();
        // let minArr = min.split('.')
        // let minLen = minArr[0].length
        // let diff = 10 ** (minLen - 1)
        // return parseInt(value.max + diff)

        let diff = value.max - value.min
        let max = value.max;
        if (diff < value.min) {
          max = value.max + diff / 2;
        } else {
          max = value.max + value.min;
        }

        return Math.floor(max)

        // return Math.floor(value.max)
      },
    },
    series: [
      {
        data: data.series,
        type: 'line',
        areaStyle: {
        }
      }
    ],
    grid: {
      top: "20px",
      left: "56px",
      right: "20px",
      bottom: "30px"
    }
  }
}
</script>

<style scoped lang="scss">
.page {
  width: 100%;
  background: radial-gradient( 0% 0% at 50% 50%, #00082E 0%, #030732 100%);
  height: 100vh;
  overflow: auto;

  .header-wp {
    width: 100%;
    position: relative;
    overflow: hidden;

    .bg-header {
      width: 100%;
      position: relative;
      z-index: 0;
      display: block;
    }

    .text-wp {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;

      .text-inner-wp {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .title {
          font-size: 18px;
          font-weight: bold;
          color: #FFFFFF;
        }
      }
    }
  }

  .date-wp {
    margin-top: 28px;
    text-align: center;

    .text {
      font-size: 16px;
      font-weight: bold;
      color: #5EBFFF;
    }
  }

  .title-content {
    display: flex;
    align-items: center;
    height: 20px;
    margin-top: 24px;
    padding: 0 20px;
    box-sizing: border-box;

    .svg-icon {
      width: 12px;
      height: 14px;
    }

    .text {
      margin-left: 8px;
      font-size: 16px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 20px;
    }

    &.title-2 {
      margin-top: 17px;
    }

    &.title-3 {
      margin-top: 16px;
    }
  }

  .line-2-wp {
    margin: 12px 20px 0 20px;
    background: linear-gradient( 180deg, #09175F 0%, rgba(16,45,56,0.72) 51%, #0D1A6B 100%);
    box-shadow: inset 0px 3px 6px 1px #112890;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid rgba(40,141,255,0.25);
    width: calc(100% - 40px);
    position: relative;
    overflow: hidden;

    .bg-item {
      width: 100%;
      position: relative;
      z-index: 0;
      display: block;
      opacity: 0.6;
    }

    .item-content-wp {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;

      .item-content-inner-wp {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 6%;
        box-sizing: border-box;

        .item-wp {
          display: flex;
          align-items: center;
          flex: 1;
          justify-content: center;

          .icon-wp {
            width: 42%;
            flex-shrink: 0;

            .icon-1 {
              width: 100%;
            }

            .icon-2 {
              width: 100%;
            }
          }

          .item-value-wp {
            margin-left: 18px;

            .value-row-1-wp {
              .value-1 {
                font-weight: bold;
                color: #389EFF;
                font-size: 21px;
              }

              .value-1-unit {
                font-weight: 400;
                color: #389EFF;
                font-size: 11px;
                margin-left: 12px;
                align-self: flex-end;
              }
            }

            .value-row-2-wp {
              .value-2 {
                font-weight: 400;
                color: #FFFFFF;
                font-size: 11px;
              }
            }
          }
        }
      }
    }
  }

  .line-3-wp {
    margin: 10px 20px 0 20px;
    background: linear-gradient( 180deg, #09175F 0%, rgba(16,45,56,0.72) 51%, #0D1A6B 100%);
    box-shadow: inset 0px 3px 6px 1px #112890;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid rgba(40,141,255,0.25);
    width: calc(100% - 40px);
    position: relative;
    overflow: hidden;

    .bg-item {
      width: 100%;
      position: relative;
      z-index: 0;
      display: block;
      opacity: 0.6;
    }

    .item-content-wp {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;

      .item-content-inner-wp {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 6%;
        box-sizing: border-box;

        .item-wp {
          display: flex;
          align-items: center;
          flex: 1;
          justify-content: center;

          .icon-wp {
            width: 42%;
            flex-shrink: 0;

            .icon-1 {
              width: 100%;
            }

            .icon-2 {
              width: 100%;
            }
          }

          .item-value-wp {
            margin-left: 18px;

            .value-row-1-wp {
              .value-1 {
                font-weight: bold;
                color: #389EFF;
                font-size: 21px;
              }

              .value-1-unit {
                font-weight: 400;
                color: #389EFF;
                font-size: 11px;
                margin-left: 12px;
              }
            }

            .value-row-2-wp {
              .value-2 {
                font-weight: 400;
                color: #FFFFFF;
                font-size: 11px;
              }
            }
          }
        }
      }
    }
  }

  .line-4-wp, .line-5-wp {
    width: calc(100% - 40px);
    position: relative;
    overflow: hidden;
    margin: 15px 20px 0 20px;
    background: linear-gradient( 180deg, #09175F 0%, rgba(16,45,56,0.72) 51%, #0D1A6B 100%);
    box-shadow: inset 0px 3px 6px 1px #112890;
    border-radius: 2px 2px 2px 2px;

    .bg-3, .bg-4 {
      width: 100%;
      position: relative;
      z-index: 0;
      display: block;
      opacity: 0.6;
    }

    .item-content-wp {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;

      .item-content-inner-wp {
        height: 100%;
        width: 100%;

        .title-wp {
          display: flex;
          align-items: center;
          height: 20px;
          margin-left: 24px;
          margin-top: 28px;

          .svg-icon {
            width: 12px;
            height: 14px;
          }

          .text {
            margin-left: 8px;
            font-size: 16px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 20px;
          }
        }

        .number-wp {
          width: 100%;
          position: relative;
          overflow: hidden;
          margin-top: 15px;

          .icon-wp {
            width: 100%;
            position: relative;
            z-index: 0;
            text-align: center;
            display: flex;
            justify-content: center;
            flex: 1;

            .icon {
              width: 70%;
              display: block;
            }
          }

          .number-item-content-wp {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 100%;
            width: 100%;

            .number-item-content-inner-wp {
              height: 100%;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;

              .text {
                font-size: 26px;
                font-weight: bold;
                color: #FFFFFF;
              }
            }
          }
        }

        .progress-wp {
          margin-top: 62px;
          display: flex;
          align-items: center;
          justify-content: center;

          .progress-item-wp {
            display: flex;
            flex-direction: column;
            justify-content: center;

            .text {
              font-size: 17px;
              color: #FFFFFF;
              font-weight: 400;
            }

            .value {
              font-size: 20px;
              color: #389EFF;
              font-weight: bold;
              margin-top: 14px;
            }
          }
          .sep-v {
            width: 1px;
            background: #389EFF;
            height: 40px;
            margin: 0 32px;
          }
        }
      }
    }
  }

  .line-6-wp {
    width: calc(100% - 40px);
    position: relative;
    overflow: hidden;
    margin: 18px 20px 0 20px;

    .bg-item {
      width: 100%;
      position: relative;
      z-index: 0;
      display: block;
      opacity: 0.6;
    }

    .item-content-wp {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;
      padding: 4px;
      box-sizing: border-box;

      .item-content-inner-wp {
        height: 100%;
        width: 100%;

        .chart {
          height: 100%;
          width: 100%;
        }
      }
    }
  }

  .line-7-wp {
    width: calc(100% - 40px);
    position: relative;
    overflow: hidden;
    margin: 18px 20px 0 20px;

    .bg-item {
      width: 100%;
      position: relative;
      z-index: 0;
      display: block;
      opacity: 0.6;
    }

    .item-content-wp {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;
      padding: 14px 18px;
      box-sizing: border-box;

      .item-content-inner-wp {
        height: 100%;
        width: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
        &::-webkit-scrollbar {
          display: none;
        }

        .zx-wp {
          .zx-item-wp {
            display: flex;
            flex-direction: column;
            margin-bottom: 12px;

            .zx-date {
              font-size: 12px;
              color: #389EFF;
              font-weight: 400;
            }

            .zx-title {
              font-size: 14px;
              color: #FFFFFF;
              font-weight: 400;
            }
          }
        }
      }
    }
  }

  .line-8-wp, .line-9-wp {
    width: calc(100% - 40px);
    margin: 18px 20px 0 20px;

    .title-content {
      display: flex;
      align-items: center;
      height: 20px;

      .svg-icon {
        width: 12px;
        height: 14px;
      }

      .text {
        margin-left: 8px;
        font-size: 16px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 20px;
      }
    }

    .chart-wp {
      margin-top: 18px;
      width: 100%;
      position: relative;
      overflow: hidden;

      .bg-item {
        width: 100%;
        position: relative;
        z-index: 0;
        display: block;
        opacity: 0.6;
      }

      .item-content-wp {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        width: 100%;

        .item-content-inner-wp {
          height: 100%;
          width: 100%;
        }
      }
    }
  }

  .line-9-wp {
    margin-bottom: 36px;
  }
}
</style>
